import { createSlice } from "@reduxjs/toolkit";
import {
  getReportsBuilder,
  downloadReportBuilder,
  generateReportBuilder,
  getReportStatsBuilder,
  deleteReportsBuilder,
} from "./builder";

const initialState = {
  reports: {
    data: [],
    loading: false,
    deleteLoading: false,
    error: null,
    pagination: {
      currentPage: 1,
      totalPages: 0,
      totalItems: 0,
      itemsPerPage: 5,
      hasNextPage: false,
      hasPreviousPage: false,
    },
  },
  generation: {
    loading: false,
    error: null,
    lastGenerated: null,
  },
  download: {
    loading: false,
    error: null,
  },
  stats: {
    totalReports: 0,
    completedReports: 0,
    pendingReports: 0,
    failedReports: 0,
    totalDownloads: 0,
    totalSizeMB: 0,

    loading: false,
    error: null,
  },
};

export const reportsSlice = createSlice({
  name: "reportsInfo",
  initialState,
  reducers: {
    clearGenerationError: (state) => {
      state.generation.error = null;
    },
    clearDownloadError: (state) => {
      state.download.error = null;
    },
  },
  extraReducers: (builder) => {
    getReportsBuilder(builder);
    generateReportBuilder(builder);
    downloadReportBuilder(builder);
    deleteReportsBuilder(builder);
    getReportStatsBuilder(builder);
    // Handle logout - clear all data
    builder.addCase("auth/logout", (state) => {
      return initialState;
    });
  },
});

// Export synchronous actions
export const { clearGenerationError, clearDownloadError } =
  reportsSlice.actions;

// Selectors
export const selectReports = (state) => state.reportsInfo.reports;
export const selectReportGeneration = (state) => state.reportsInfo.generation;
export const selectReportDownload = (state) => state.reportsInfo.download;
export const selectReportStats = (state) => state.reportsInfo.stats;

export default reportsSlice.reducer;
